/*____________ Config ____________*/
const mainColor = 0x325637

export let tour = {
    title: 'Chestnut Lake',
    map: false,
    infoSidebar: false,
    watermark: true,
    websiteUrl: 'https://www.chestnutlakecamp.com/',
    requestInfoUrl: 'https://www.chestnutlakecamp.com/request-information/',

    colors: {
        hamburgerMenuColor: mainColor,
        nextSceneColor: mainColor,
        prevSceneColor: mainColor,
        thumbsGridColor: mainColor,
        loadingAnimationColor: mainColor,
    },
    
    loadingLogo: {
        src: './images/logo.png',
        width: 250,
    },

    logo: {
        src: './images/logo.png',
        width: 175,
    },

    mapLogo: false,
}

/*____________ Stores ____________*/

/**
 * https://svelte.dev/docs#run-time-svelte-store-writable
 * 
 * store = writable(value?: any, start?: (set: (value: any) => void) => () => void)
 * 
 * Function that creates a store which has values that can be set from 'outside' components. 
 * It gets created as an object with additional set and update methods.
 * 
 * store = readable(value?: any, start?: (set: (value: any) => void) => () => void)
 * 
 * Creates a store whose value cannot be set from 'outside', 
 * the first argument is the store's initial value, 
 * and the second argument to readable is the same as the second argument to writable.
 */ 

import { writable } from 'svelte/store';

tour.scenes = writable([]);

if(typeof tour.map === 'object'){
    tour.mapZoom = writable();
}

/*____________ Tour Functions ____________*/

tour.switchView = () => {
    expandedTour = !expandedTour
    expandedMap = !expandedMap
    expandedTour ? showHotspots() : hideHotspots();
    setMapZoom();
}

tour.setMapZoom = () => {
    let zoomExpandedMap = 16.75
    let zoomMiniMap = 15
    let zoomLevel = expandedMap ? zoomExpandedMap : zoomMiniMap
    tour.mapZoom.set(zoomLevel);
    return zoomLevel;
}

tour.showHotspots = () => {
    console.log('show_hotspots')
    window.CC.krpano.call('show_hotspots');
}

tour.hideHotspots = () => {
    console.log('hide_hotspots')
    window.CC.krpano.call('hide_hotspots');
}

tour.nextScene = () => {
    window.CC.krpano.call('nextscene_loop(+1)')
}

tour.prevScene = () => {
    window.CC.krpano.call('nextscene_loop(-1)')
}

tour.parseContent = (content) => {
    return content
        .replaceAll('[', '<')
        .replaceAll(']', '>')
}

tour.loadScene = (scene, callback) => {
    let sceneName;
    if(typeof scene === 'object'){ sceneName = scene.name; }
    if(typeof scene === 'string'){ sceneName = scene; }
    window.CC.krpano.call("loadscene(" + scene + ",null,get(skin_settings.loadscene_flags),get(skin_settings.loadscene_blend));");
    if(typeof callback === 'function'){ callback(); }
}

tour.loadStartScene = (callback) => {
    tour.loadScene('get(scene[0].name)', callback);
}

tour.getSceneTitle = (scene) => {
    let sceneTitle = window.CC.krpano.get('scene[' + scene + '].title');
    return sceneTitle;
}

tour.getStartSceneTitle = () => {
    return tour.getSceneTitle('get(scene[0].name)');
}

tour.title = tour.parseContent(tour.title);

tour.currentScene = {
    getName: () => {
        return window.CC.krpano.get('xml.scene')
    },

    getIndex: () => {
        return window.CC.krpano.get('scene[get(xml.scene)].index')
    },

    getHotspots: () => {
        let validStyles = [
            'skin_hotspotstyle', 
            'skin_hotspotstyle_balloon',
        ]

        let hotspots = 
            window.CC.krpano.get('hotspot').getArray()
            .filter((hs)=>{
                return validStyles.includes(hs.style)
            })
        
        return hotspots;
    },

    removeHotspot: (hs) => {
        window.CC.krpano.call('removehotspot(' + hs.name + ')');
    },


    getContent: () => {
        return window.CC.krpano.get('xml').content
    },
}
